import React, { useState, useRef, useCallback, useEffect } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import Form, {
  Item,
  Label,
  ButtonItem,
  ButtonOptions,
  RequiredRule,
  CompareRule, PatternRule, StringLengthRule
} from 'devextreme-react/form'
import LoadIndicator from 'devextreme-react/load-indicator'
import notify from 'devextreme/ui/notify'
import { changePassword, checkRecoveryCode } from '../../api/auth'
import './change-password-form.scss'
import Validator from "devextreme/ui/validator";
import {getPass, validPass} from "../../utils/get-password-rules";
const eyeclose = require("./../../assets/eyeclose.svg").default
const eyeopen = require("./../../assets/eyeopen.svg").default
let formInstance
const ChangePasswordForm = () => {
  const history = useHistory()
  const [loading, setLoading] = useState(false)
  const formData = useRef({})
  const { recoveryCode, isset } = useParams()
  const [passwordIcon, setPasswordIcon] = useState(eyeclose)
  const [passwordConfirmIcon, setPasswordConfirmIcon] = useState(eyeclose)
  const [passwordMode, setPasswordMode] = useState('password')
  const [passwordConfirmMode, setPasswordConfirmMode] = useState('password')

  const [passwordRulesLabel, setPasswordRulesLabel] = useState('Пароль должен состоять минимум из 8 символов, содержать как минимум одну цифру и 2 заглавные буквы')
  useEffect(() => {
    (async function () {
      try {
        const res = await getPass()
        setPasswordRulesLabel(res)
      } catch (e) {
        notify(e.message, 'error', 5000)
      }
    })()
  }, [])

  const onSubmit = useCallback(async (e) => {
    e.preventDefault();
    const { password } = formData.current
    setLoading(true)

    const result = await changePassword(password, recoveryCode, isset === 'true')
    setLoading(false)

    if (result.isOk) {
      history.push('/login');
      notify(result.message, 'success',5000)
    } else {
      notify(result.message, 'error', 5000)
    }
  }, [history, recoveryCode, isset])

  useEffect(()=> {
    (async function(){
      const res = await checkRecoveryCode(recoveryCode)
      if (res.isOk && !res.data.success) {
        notify(res.data.message, 'error', 5000)
        history.push('/login')
      }
    })()
  },[history,recoveryCode])

  // const confirmPassword = useCallback(
  //   ({ value }) => value === formData.current.password,
  //   []
  // );

  const confirmPassword = () =>{
    return formData.current.password
  };

  const passwordEditorOptions = {
    placeholder: 'Пароль',
    mode: passwordMode,
    valueChangeEvent:"keyup",
    onValueChanged:async (e) => {
      const editor = formInstance && formInstance.getEditor('ConfirmPassword');
      if (editor && editor.option('value')) {
        const instance = Validator.getInstance(editor.element());
        instance.validate();
      }

      const editorPassword = formInstance && formInstance.getEditor('password');
      if (editorPassword) {
        const instance = Validator.getInstance(editorPassword.element());
        if (await validPass(e.value, passwordRulesLabel.data)) {
          instance._validationRules[0].isValid = false
        }
        instance.validate();
      }
    },
    buttons: [{
      name: 'password',
      location: 'after',
      options: {
        icon: passwordIcon,
        type: 'default',
        onClick() {
          setPasswordMode(passwordMode === 'text' ? 'password' : 'text');
          setPasswordIcon(passwordIcon === eyeclose ? eyeopen : eyeclose)
        },
      },
    }]
  };

  const confirmedPasswordEditorOptions = {
    placeholder: 'Подтверждение пароля',
    mode: passwordConfirmMode,
    buttons: [{
      name: 'password',
      location: 'after',
      options: {
        icon: passwordConfirmIcon,
        type: 'default',
        onClick() {
          setPasswordConfirmMode(passwordConfirmMode === 'text' ? 'password' : 'text');
          setPasswordConfirmIcon(passwordConfirmIcon === eyeclose ? eyeopen : eyeclose)
        },
      },
    }]
  };

  // const checkPassword = useCallback(
  //   ({ value }) => (formData.current.confirmedPassword ? value === formData.current.confirmedPassword : true),
  //   []
  // );
  const onInitialized = (e) => {
    formInstance = e.component;
  }
  return (
      <form className="change-password-form" onSubmit={onSubmit}>
        <Form formData={formData.current} onInitialized={onInitialized} disabled={loading} labelMode="floating" labelLocation="left">
          <Item
              dataField={'password'}
              editorType={'dxTextBox'}
              editorOptions={passwordEditorOptions}
          >
            <PatternRule pattern="^.*$" message={passwordRulesLabel.passTxt} />
            <StringLengthRule min={8} message={passwordRulesLabel.passTxt} />
            <RequiredRule message={'Пароль обязателен'} />
            <Label text="Пароль" />
            {/*<CustomRule*/}
            {/*  message={'Пароли не совпадают'}*/}
            {/*  validationCallback={checkPassword}*/}
            {/*/>*/}
          </Item>
          <Item
              name="ConfirmPassword"
              dataField={'confirmedPassword'}
              editorType={'dxTextBox'}
              editorOptions={confirmedPasswordEditorOptions}
          >
            <RequiredRule message="Пароль задан неверно" />
            {/*<CustomRule*/}
            {/*  message={'Пароли не совпадают'}*/}
            {/*  validationCallback={confirmPassword}*/}
            {/*/>*/}
            <CompareRule
                message="Пароль и подтверждение пароля не совпадают"
                comparisonTarget={confirmPassword}
            />
            <Label text="Подтверждение пароля" />
          </Item>
          <Item>
            <div className="text">{passwordRulesLabel.passTxt}</div>
          </Item>
          <ButtonItem>
            <ButtonOptions
                width={'100%'}
                type={'default'}
                useSubmitBehavior={true}
            >
            <span className="dx-button-text">
              {
                loading
                    ? <LoadIndicator width={'24px'} height={'24px'} visible={true} />
                    : isset === "true" ? 'Установить пароль':'Сменить пароль'
              }
            </span>
            </ButtonOptions>
          </ButtonItem>
        </Form>
      </form>
  );
}

export default ChangePasswordForm
